// GLOBAL VARIABLES

// MESSAGE TIMEOUT
// Timeout when a message will disappear. Error messages have not applied the timeout and need to be cleared be the user.
var $global_message_timeout = 5; // [in Seconds]

export { $global_message_timeout };
